import pl from "@locales/patient/health_and_goal/body_measurement_tab/pl.json";
import en from "@locales/patient/health_and_goal/body_measurement_tab/en.json";

export default {
  pl: pl,
  en: en,
};
